import { Reducer } from 'redux';
import {
  AppointActionTypes,
  AppointState,
  IPhysicalPerson,
  IPhysicalRightsItem,
  PhysicalPersonLockedFields,
  PhysicalType,
  ReportAuthorizedStatus,
} from './type';

const initialGoodsInfo = {
  SZ_BODY: {
    CREDIT_RULE: null,
    requiredAdd: [],
    optionalAdd: [],
    goods: {
      activityCode: '',
      goodsAmtStr: '',
      goodsPath: '',
      goodsName: '',
      endTime: '',
      goodsPictureUrl: '',
      goodsCode: '',
    },
  },
};

export const initialInstit = {
  institCode: '',
  institName: '',
  institAddr: '',
  latitude: '',
  longitude: '',
  corpBrand: '',
  brandLogoPath: '',
  distanceStr: 0,
  letest6DayReserveDate: {},
};

export const initialState: AppointState = {
  selectedDate: '',
  selectedInstit: initialInstit,
  selectedCity: [] as Array<{ label: string; value: string }>,
  selectedCityLocation: null,
  selectedGoodsInfo: initialGoodsInfo,
  selectedRequiredAddItems: [],
  selectedOptionalAddItems: [],
  selectedPhysicalPerson: {} as IPhysicalPerson,
  physicalPersonLockedFields: {} as PhysicalPersonLockedFields,
  selectedPhysicalType: PhysicalType.EMPLOYEE,
  selectedPhysicalRightsItem: {} as IPhysicalRightsItem,
  selectedPhysicalRightsList: [] as IPhysicalRightsItem[],
  reportAuthorized: ReportAuthorizedStatus.NOT_AUTHORIZED,
  userRightsId: undefined,
};

const reducer: Reducer<AppointState> = (state = initialState, action) => {
  switch (action.type) {
  case AppointActionTypes.SET_SELECTED_DATE: {
    return {
      ...state,
      selectedDate: action.payload,
    };
  }
  case AppointActionTypes.SET_SELECTED_INSTIT: {
    return {
      ...state,
      selectedInstit: action.payload,
    };
  }
  case AppointActionTypes.SET_SELECTED_GOODS_INFO: {
    return {
      ...state,
      selectedGoodsInfo: action.payload,
    };
  }
  case AppointActionTypes.SET_SELECTED_REQUIRED_ADD_ITEMS: {
    return {
      ...state,
      selectedRequiredAddItems: action.payload,
    };
  }
  case AppointActionTypes.SET_SELECTED_OPTIONAL_ADD_ITEMS: {
    return {
      ...state,
      selectedOptionalAddItems: action.payload,
    };
  }
  case AppointActionTypes.SET_SELECTED_PHYSICAL_PERSON: {
    return {
      ...state,
      selectedPhysicalPerson: {
        ...state.selectedPhysicalPerson,
        ...action.payload,
      },
    };
  }
  case AppointActionTypes.SET_SELECTED_PHYSICAL_RIGHTS_ITEM: {
    return {
      ...state,
      selectedPhysicalRightsItem: action.payload,
    };
  }
  case AppointActionTypes.SET_SELECTED_PHYSICAL_RIGHTS_LIST: {
    return {
      ...state,
      selectedPhysicalRightsList: action.payload,
    };
  }
  case AppointActionTypes.SET_REPORT_AUTHORIZED_STATUS: {
    return {
      ...state,
      reportAuthorized: action.payload,
    };
  }
  case AppointActionTypes.SET_SELECTED_PHYSICAL_TYPE: {
    return {
      ...state,
      selectedPhysicalType: action.payload,
    };
  }
  case AppointActionTypes.SET_SELECTED_CITY: {
    return {
      ...state,
      selectedCity: action.payload,
    };
  }
  case AppointActionTypes.SET_SELECTED_CITY_LOCATION: {
    return {
      ...state,
      selectedCityLocation: action.payload,
    };
  }
  case AppointActionTypes.SET_USER_RIGHTS_ID: {
    return {
      ...state,
      userRightsId: action.payload,
    };
  }
  case AppointActionTypes.SET_PHYSICAL_PERSON_LOCKED_FIELDS: {
    return {
      ...state,
      physicalPersonLockedFields: {
        ...state.physicalPersonLockedFields,
        ...action.payload,
      },
    };
  }
  case AppointActionTypes.CLEAR_PHYSICAL_GOODS_INFO: {
    return {
      ...state,
      selectedDate: '',
      selectedInstit: initialInstit,
      selectedCity: [],
      selectedGoodsInfo: initialGoodsInfo,
      selectedRequiredAddItems: [],
      selectedOptionalAddItems: [],
      selectedPhysicalRightsItem: {} as IPhysicalRightsItem,
      selectedPhysicalPerson: {} as IPhysicalPerson,
      physicalPersonLockedFields: {} as PhysicalPersonLockedFields,
    };
  }
  default: {
    return state;
  }
  }
};

// export { AppointState }; // Rsbuild 处理 TypeScript 类型导出有问题
export default reducer;
